import { defaultFont } from "assets/jss/material-kit-react.jsx";

import tooltip from "assets/jss/material-kit-react/tooltipsStyle.jsx";

const headerLinksStyle = theme => ({
  list: {
    ...defaultFont,
    fontSize: "14px",
    margin: 0,
    padding: "0",
    listStyle: "none",
    // color: "#222222",
    color: "inherit",
  },
  listItem: {
    float: "left",
    color: "inherit",
    position: "relative",
    display: "inline-block",
    width: "auto",
    marginLeft: 5,
    // marginRight: 5,
    padding: "0",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      "&:after": {
        width: "calc(100% - 30px)",
        content: '""',
        display: "block",
        height: "1px",
        marginLeft: "15px",
        backgroundColor: "#e5e5e5"
      }
    }
  },
  listItemText: {
    padding: "0 !important"
  },
  navLink: {
    position: "relative",
    // padding: "0.9375rem",
    // padding: "20px",
    paddingHorizontal: "5px",
    fontWeight: "400",
    fontSize: "18px",
    letterSpacing: 1,
    textTransform: "none",
    // borderRadius: "3px",
    // lineHeight: "20px",
    textDecoration: "none",
    verticalAlign: "top",
    textAlign: "left",
    // margin: "0px",
    marginLeft: "auto",
    marginRight: "auto",
    // paddingTop: "25px",
    // paddingBottom: "15px",
    borderBottom: "3px solid transparent",
    borderRadius: 0,
    display: "inline-block",
    "&:hover,&:focus": {
      // paddingBottom: 10,
      borderBottom: "3px solid #ff3e4b",
      // color: "#333434",
      borderRadius: 0,
      color: "inherit",
      // background: "rgba(200, 200, 200, 0.2)",
    },
    [theme.breakpoints.down("sm")]: {
      width: "calc(100% - 30px)",
      marginLeft: "15px",
      marginBottom: "8px",
      marginTop: "8px",
      textAlign: "left",
      "& > span:first-child": {
        justifyContent: "flex-start"
      }
    }
  },
  navLinkCTA: {
    position: "relative",
    // padding: "20px",
    paddingHorizontal: "5px",
    fontWeight: "400",
    fontSize: "18px",
    letterSpacing: 1,
    textTransform: "none",
    textDecoration: "none",
    verticalAlign: "top",
    textAlign: "left",
    marginLeft: "auto",
    marginRight: "auto",
    // paddingTop: "25px",
    // paddingBottom: "15px",
    display: "inline-block",
    // "&:hover,&:focus": {
    //   paddingBottom: 10,
    //   borderBottom: "3px solid #ff3e4b",
    //   borderRadius: 0,
    //   color: "inherit",
    // },
    [theme.breakpoints.down("sm")]: {
      width: "calc(100% - 30px)",
      marginLeft: "15px",
      marginBottom: "8px",
      marginTop: "8px",
      textAlign: "left",
      "& > span:first-child": {
        justifyContent: "flex-start"
      }
    }
  },
  notificationNavLink: {
    color: "inherit",
    padding: "0.9375rem",
    fontWeight: "400",
    fontSize: "12px",
    textTransform: "uppercase",
    lineHeight: "20px",
    textDecoration: "none",
    margin: "0px",
    display: "inline-flex",
    top: "4px"
  },
  registerNavLink: {
    top: "3px",
    position: "relative",
    fontWeight: "400",
    fontSize: "12px",
    textTransform: "uppercase",
    lineHeight: "20px",
    textDecoration: "none",
    margin: "0px",
    display: "inline-flex"
  },
  navLinkActive: {
    color: "inherit",
    backgroundColor: "rgba(255, 255, 255, 0.1)"
  },
  icons: {
    width: "20px",
    height: "20px",
    marginRight: "3px"
  },
  socialIcons: {
    position: "relative",
    fontSize: "20px !important",
    marginRight: "4px"
  },
  dropdownLink: {
    "&,&:hover,&:focus": {
      color: "inherit",
      textDecoration: "none",
      display: "block",
      padding: "10px 20px",
    }
  },
  ...tooltip,
  marginRight5: {
    marginRight: "5px"
  }
});

export default headerLinksStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/components/headerLinksStyle.jsx